import { Typography } from "@material-ui/core";
import React from "react";

export default function Switch({
  switchTextWhenOn,
  switchTextWhenOff,
  switchWidth = 75,
  switchValue,
  switchDefault = false,
  switchLang = "eng",
}) {
  const [on, setOn] = React.useState(switchDefault);
  React.useEffect(() => {
    switchValue(on);
  }, [on]);
  const container = {
    width: switchWidth,
    height: 36,
    borderRadius: 32,
    position: "relative",
    cursor: "pointer",
    direction: "ltr",
    //WebkitTapHighlightColor: "transparent",
    //outline: "none",
  };

  const ellipseOn = {
    width: 30,
    height: 30,
    borderRadius: "50%",
    position: "relative",
    top: 3,
    background: `#FFFFFF`,
    transition: "left 0.2s",
  };

  const textLeft = switchLang === "eng" ? 45 : 85;

  const text = {
    // fontSize: 14,
    // fontWeight: 400,

    position: "absolute",
    color: "white",
    top: 7.5,
    transition: "left 0.2s",
    userSelect: "none",
    //WebkitTapHighlightColor: "transparent",
    //outline: "none",
  };
  const textOn = (
    <div>
      <span style={{ display: "inline-block" }}>{switchTextWhenOn} </span>
    </div>
  );
  return (
    <div
      style={{
        display: "flex",
        WebkitTapHighlightColor: "transparent",
        outline: "none",
      }}
    >
      <div
        style={{ ...container, background: on ? `#004E5E` : "#3B8CA8" }}
        onClick={() => {
          setOn((prev) => !prev);
        }}
      >
        <div style={{ ...ellipseOn, left: on ? 2 : switchWidth - 32 }}></div>
        <span
          style={{
            ...text,
            left: on ? textLeft : 10,
            marginLeft: on ? "" : "8px",

            color: !on ? "white" : "white",
          }}
        >
          {" "}
          <Typography variant="body2">
            {on ? switchTextWhenOn : switchTextWhenOff}
          </Typography>
        </span>
      </div>
    </div>
  );
}
